module.exports = __webpack_public_path__ + "img/0Q3A4226_L_Black.043113c5.jpg";